import { QueryFunctionContext, useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { ONE_HOUR } from '@constants';
import { VideosResponse, VideosResult } from '@common/types/api';
import { VIDEOS_ENDPOINT } from '@constants/endpoints';
import { api } from '@services';
import { PromiseWithCancel } from '@common/types';
import { cancelToken } from '@services/api';

import { useEventfy } from '../useEventfy';
import { selectHasVideos } from '../useEventfy/selectors';

const fetchVideosWithCategory = (
  ctx: QueryFunctionContext<[string, number, number | undefined]>,
) => {
  const [, page, categoryId] = ctx.queryKey;

  const source = cancelToken();

  let url = `${VIDEOS_ENDPOINT}?limit=15&page=${page}`;
  if (categoryId) {
    url += `&category_id=${categoryId}`;
  }

  const promise = api
    .get<VideosResponse>(url, {
      cancelToken: source.token,
    })
    .then((response) => {
      const { data: videos, meta } = response.data;

      return { videos, meta } as VideosResult;
    }) as PromiseWithCancel<VideosResult>;

  promise.cancel = () => source.cancel('useVideosQuery Cancelled');

  return promise;
};

export const useVideosQuery = (page = 1, categoryId?: number) => {
  const eventHasVideos = useEventfy(selectHasVideos);

  return useQuery<VideosResult, AxiosError>(
    ['videos', page, categoryId],
    fetchVideosWithCategory,
    {
      enabled: eventHasVideos,
      staleTime: ONE_HOUR * 24,
    },
  );
};
